import { Card, EmptyState, PageLayout } from '@orbind/ui'
import { useLocation } from 'react-router'
import { MODULES } from '../shell/modules.ts'

/**
 * Tela ainda nao construida.
 *
 * Em vez de um "404" ou de um mock decorativo, mostra o que a tela vai fazer e
 * qual e a referencia dela na spec. Assim a navegacao do protótipo continua
 * inteira e fica explicito o que falta implementar.
 */
export function PlaceholderPage({ title, specId, summary }: { title?: string; specId?: string; summary?: string }) {
  const location = useLocation()
  const module = MODULES.find((m) => location.pathname.startsWith(`/${m.route.split('/')[1]}`))

  const resolvedTitle = title ?? module?.fallbackLabel ?? 'Em construção'
  const resolvedSpec = specId ?? module?.specId ?? '—'
  const resolvedSummary = summary ?? module?.summary ?? 'Tela prevista no mapa de rotas da plataforma.'

  return (
    <PageLayout title={resolvedTitle} subtitle={`Rota ${location.pathname}`}>
      <Card>
        <EmptyState
          icon="fas fa-drafting-compass"
          title="Ainda não implementada"
          description={`${resolvedSummary} Referência na spec: ${resolvedSpec}.`}
        />
      </Card>
    </PageLayout>
  )
}
